import Env from '../../base/env'
import gsap from 'gsap'

export default class Haikus
{
  constructor(view)
  {
    this.view = view
    this.$collection = this.view.querySelector('.jsCollection')
    this.btnMore = this.view.querySelector('.jsMore')
    this.datas = JSON.parse(this.view.querySelector('.jsData').value)
    this.$item1 = this.view.querySelector('.jsItem1')
    this.$item2 = this.view.querySelector('.jsItem2')
    this.$animates = [this.$item1,this.$item2]
    this.TOTAL = this.datas.length - 1
    this.CURRENT_INDEX = 0
    //
    this.randomize()
    this.events()
    this.display()
  }

  animate()
  {
    const tl = gsap.timeline()

    tl.add(
      gsap.fromTo(this.$animates , { autoAlpha: 1 , y : 0 } , { autoAlpha : 0 , stagger:.1, ease: 'power3.out' , duration : .5 })
    )
    tl.add(()=>{
      this.display()
    })
    tl.add(
      gsap.fromTo(this.$animates , { y : 20 } , { immediateRender:false, autoAlpha : 1 , y : 0 , stagger:.1, ease: 'power3.out' , duration : 1 })
    ,'+=.2')
  }

  display()
  {
    if(typeof this.rDatas[this.CURRENT_INDEX] != 'undefined') {
      const item1 = this.template(this.rDatas[this.CURRENT_INDEX])
      this.$item1.innerHTML = item1
    } else {
      this.$item1.innerHTML = ''
    }
    if(typeof this.rDatas[this.CURRENT_INDEX + 1] != 'undefined') {
      const item2 = this.template(this.rDatas[this.CURRENT_INDEX + 1])
      this.$item2.innerHTML = item2
    } else {
      this.$item2.innerHTML = ''
    }
  }

  events()
  {


    this.btnMore.addEventListener('click',()=>{
      if(Env.mobileCSS == true) {
        this.CURRENT_INDEX++
      } else {
        this.CURRENT_INDEX+=2
      }

      if(this.CURRENT_INDEX > this.TOTAL) {
        this.CURRENT_INDEX = 0
      }
      this.animate()
    })
  }

  randomize()
  {
    // this.rDatas = Env.framework.toolbox.shuffled(this.datas);
    this.rDatas = this.datas;
  }

  template(data)
  {
    const html = `
    <h5 class="tw-text-ebonyclay tw-text-2xl tw-leading-10 tw-font-sans-dp-lt">${data.comment}</h5>
    <h6 class="tw-text-ebonyclay tw-text-sm tw-font-sans-txt-rg tw-mt-3">${data.author}</h6>`
    return html
  }
}
